var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircleIcon, DocumentTextIcon, PhoneXMarkIcon, PresentationChartLineIcon, StopIcon, VideoCameraIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { AIAdoptionAndUsageSection } from '@web/components/PerformanceReview/Employee/Sections/AIAdoption&Usage';
import { CommunicationSection } from '@web/components/PerformanceReview/Employee/Sections/Communication';
import { DailyTimelineSection } from '@web/components/PerformanceReview/Employee/Sections/DailyTimeline';
import { InitiativeAndOwnershipSection } from '@web/components/PerformanceReview/Employee/Sections/Initiative&Ownership';
import { OverviewSection } from '@web/components/PerformanceReview/Employee/Sections/Overview';
import { PolicyComplianceSection } from '@web/components/PerformanceReview/Employee/Sections/PolicyCompliance';
import { ScheduleAndAttendanceSection } from '@web/components/PerformanceReview/Employee/Sections/Schedule&Attendance';
import { TimeManagement } from '@web/components/PerformanceReview/Employee/Sections/TimeManagement';
import { WorkLifeBalanceSection } from '@web/components/PerformanceReview/Employee/Sections/WorkLifeBalance';
import { FolderIcon } from '@web/components/ui/icons/FolderIcon';
import { GoogleDocIcon } from '@web/components/ui/icons/GoogleDocIcon';
import { GoogleSlidesIcon } from '@web/components/ui/icons/GoogleSlidesIcon';
import { OtherSheetIcon } from '@web/components/ui/icons/OtherSheetIcon';
import { PdfIcon } from '@web/components/ui/icons/PdfIcon';
import { SheetIcon } from '@web/components/ui/icons/SheetIcon';
import { GoogleCalendarIcon } from '@web/components/ui/icons/TableIcons/GoogleCalendarIcon';
import { GoogleChatIcon } from '@web/components/ui/icons/TableIcons/GoogleChatIcon';
import { GoogleGmailIcon } from '@web/components/ui/icons/TableIcons/GoogleGmailIcon';
import { GoogleMeetIcon as GoogleMeetIconTable } from '@web/components/ui/icons/TableIcons/GoogleMeetIcon';
import { performanceInsightsUrl } from '@web/router/urls';
import { filtersToQuery } from '@web/utility/hooks/useFilters';
import { ApplicationEnum, ChatRoomTypeEnum, DocumentTypeEnum, ItemsByType, MeetEventActionEnum, MeetTimelineEventEnum, PerformanceReviewSectionsEnum, ScopeUIFilterEnum, ScopeUIPageEnum, UserRoles } from '@workalizer/shared';
import { clsx } from 'clsx';
import copy from 'copy-to-clipboard';
import { format, parseISO } from 'date-fns';
import { twMerge } from 'tailwind-merge';
export { getDriveLinkByType } from '@workalizer/shared';
export var classNames = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
};
export function cx() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return twMerge(clsx(args));
}
export var getLimitOffset = function (page, pageSize) {
    if (!page) {
        return {
            limit: pageSize,
            offset: 0
        };
    }
    return {
        limit: pageSize,
        offset: (page - 1) * pageSize
    };
};
export var getIconByType = function (type, size) {
    var iconSize = size !== null && size !== void 0 ? size : { width: '15', height: '15' };
    switch (type) {
        case DocumentTypeEnum.SPREADSHEET:
            return _jsx(SheetIcon, __assign({}, iconSize));
        case DocumentTypeEnum.DOCUMENT:
            return _jsx(GoogleDocIcon, __assign({}, iconSize));
        case DocumentTypeEnum.PRESENTATION:
            return _jsx(GoogleSlidesIcon, __assign({}, iconSize));
        case DocumentTypeEnum.PDF:
            return _jsx(PdfIcon, __assign({}, iconSize));
        case DocumentTypeEnum.FOLDER:
            return _jsx(FolderIcon, __assign({}, iconSize));
        case DocumentTypeEnum.OTHER:
            return _jsx(OtherSheetIcon, __assign({}, iconSize));
        default:
            return _jsx(OtherSheetIcon, __assign({}, iconSize));
    }
};
export var handleTimelineCellClick = function (userId, value, filters, navigate) {
    if (!userId || !value || !value.date) {
        return;
    }
    var clickedDate = format(parseISO(value.date), 'yyyy-MM-dd');
    var updatedFilters = __assign(__assign({}, filters), { user: userId, pageSection: PerformanceReviewSectionsEnum.DAILY_TIMELINE, dateFrom: clickedDate, dateTo: clickedDate, scrollY: null });
    var query = filtersToQuery(updatedFilters);
    var url = "".concat(performanceInsightsUrl, "?").concat(query);
    navigate(url);
};
export var getChatLinkByType = function (type, slugId) {
    if (!slugId) {
        throw new Error('Invalid or missing slugId');
    }
    switch (type) {
        case ChatRoomTypeEnum.ROOM:
        case ChatRoomTypeEnum.PRIVATE:
        case ChatRoomTypeEnum.USER_TO_APP_DIRECT_MESSAGE:
        case ChatRoomTypeEnum.USER_TO_USER_DIRECT_MESSAGE:
            return "https://mail.google.com/chat/u/0/#chat/dm/".concat(slugId);
        case ChatRoomTypeEnum.SPACE:
        case ChatRoomTypeEnum.THREAD:
        case ChatRoomTypeEnum.GROUP_DIRECT_MESSAGE:
            return "https://mail.google.com/chat/u/0/#chat/space/".concat(slugId);
        default:
            return "https://mail.google.com/chat/u/0/#chat/dm/".concat(slugId);
    }
};
export var getTitleForMeeting = function (meeting) {
    var _a, _b, _c;
    if ((_a = meeting === null || meeting === void 0 ? void 0 : meeting.calendar) === null || _a === void 0 ? void 0 : _a.title)
        return (_b = meeting === null || meeting === void 0 ? void 0 : meeting.calendar) === null || _b === void 0 ? void 0 : _b.title;
    var meetingGuestsEvent = (_c = meeting === null || meeting === void 0 ? void 0 : meeting.meetingGuests) !== null && _c !== void 0 ? _c : [];
    var meetingGuests = meetingGuestsEvent === null || meetingGuestsEvent === void 0 ? void 0 : meetingGuestsEvent.map(function (guest) { var _a; return (_a = guest.user.name) !== null && _a !== void 0 ? _a : guest.user.email; }).filter(Boolean).slice(0, 3);
    if (meetingGuests.length)
        return meetingGuestsEvent.length > 3
            ? "".concat(meetingGuests.join(', '), ",...")
            : meetingGuests;
    return null;
};
export var copyToClipboard = function (d) {
    copy(d);
};
export var getIconByMeetEventAction = function (action) {
    switch (action) {
        case MeetEventActionEnum.MEET_CALL_ENDED:
            return PhoneXMarkIcon;
        case MeetEventActionEnum.MEET_PRESENTATION_STARTED:
            return PresentationChartLineIcon;
        case MeetEventActionEnum.MEET_PRESENTATION_STOPPED:
            return StopIcon;
        case MeetEventActionEnum.MEET_RECORDING_ACTIVITY:
            return VideoCameraIcon;
        case MeetTimelineEventEnum.MEET_CALL_STARTED:
            return CheckCircleIcon;
        case MeetEventActionEnum.MEET_TRANSCRIPTION_ACTIVITY:
            return DocumentTextIcon;
        case MeetEventActionEnum.MEET_KNOCKING_ACCEPTED:
            return CheckCircleIcon;
        case MeetEventActionEnum.MEET_KNOCKING_DENIED:
            return XCircleIcon;
        default:
            return null;
    }
};
export var groupTimelineEvents = function (events, durationSeconds, mergeThreshold) {
    if (mergeThreshold === void 0) { mergeThreshold = 5; }
    var allEvents = events.sort(function (a, b) { return a.time - b.time; });
    var mergedEvents = [];
    var timeThreshold = (durationSeconds * mergeThreshold * 1000) / 100;
    allEvents.forEach(function (event) {
        var existingEvent = mergedEvents.find(function (merged) {
            return merged.type === event.type &&
                Math.abs(merged.startTime - event.time) <= timeThreshold;
        });
        if (existingEvent) {
            existingEvent.endTime = Math.max(existingEvent.endTime, event.time);
            if (!existingEvent.users.some(function (user) { return user.id === event.user.id; })) {
                existingEvent.users.push(event.user);
            }
        }
        else {
            mergedEvents.push({
                type: event.type,
                startTime: event.time,
                endTime: event.time + 60000,
                users: [event.user]
            });
        }
    });
    return mergedEvents;
};
export function isInsightsDataEmpty(insightsData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    if (typeof insightsData === 'object' &&
        insightsData !== null &&
        !Array.isArray(insightsData) &&
        'periods' in insightsData &&
        Array.isArray(insightsData.periods) &&
        !('totals' in insightsData)) {
        return isInsightsDataEmpty(insightsData.periods);
    }
    if (Array.isArray(insightsData)) {
        if (insightsData.length > 0) {
            var dataset = insightsData.filter(function (item) {
                return item !== null && item !== undefined;
            });
            if (dataset.length === 0) {
                return true;
            }
            if ('name' in dataset[0]) {
                return dataset.every(function (item) {
                    var values = Object.entries(item)
                        .filter(function (_a) {
                        var key = _a[0];
                        return key !== 'name';
                    })
                        .map(function (_a) {
                        var _ = _a[0], value = _a[1];
                        return value;
                    });
                    return values.every(function (value) { return value === 0 || value === null; });
                });
            }
            if ('invocations' in dataset[0]) {
                return dataset.every(function (item) { return item.invocations.count === 0; });
            }
            if ('period' in dataset[0] &&
                'currentPeriod' in dataset[0] &&
                'previousPeriod' in dataset[0] &&
                !('invocations' in dataset[0]) &&
                !('items' in dataset[0]) &&
                !('weekday' in dataset[0]) &&
                !('startWorkTime' in dataset[0])) {
                return dataset.every(function (item) {
                    var currentValues = Object.values(item.currentPeriod);
                    var previousValues = Object.values(item.previousPeriod);
                    var teamValues = item.team ? Object.values(item.team) : [];
                    var allCurrentZero = currentValues.every(function (value) { return value === 0; });
                    var allPreviousZero = previousValues.every(function (value) { return value === 0; });
                    var allTeamZero = teamValues.length === 0 || teamValues.every(function (value) { return value === 0; });
                    return allCurrentZero && allPreviousZero && allTeamZero;
                });
            }
            if ('type' in dataset[0] && 'count' in dataset[0]) {
                return dataset.every(function (item) {
                    var type = item.type, values = __rest(item, ["type"]);
                    return Object.values(values).every(function (value) { return value === 0; });
                });
            }
            if ('channel' in dataset[0] &&
                'count' in dataset[0] &&
                'prevTotal' in dataset[0] &&
                'avg' in dataset[0]) {
                return dataset.every(function (item) { return item.count === 0 && item.prevTotal === 0 && item.avg === 0; });
            }
            if ('channel' in dataset[0] &&
                'total' in dataset[0] &&
                'prevTotal' in dataset[0] &&
                'avg' in dataset[0]) {
                return dataset.every(function (item) { return item.total === 0 && item.prevTotal === 0 && item.avg === 0; });
            }
            if ('date' in dataset[0] && 'count' in dataset[0]) {
                return dataset.every(function (item) { return item.count === 0; });
            }
            if ('title' in dataset[0] &&
                'count' in dataset[0] &&
                'duration' in dataset[0]) {
                return dataset.every(function (item) { return item.count.value === 0 && item.duration.value === 0; });
            }
            if ('label' in dataset[0] &&
                'created' in dataset[0] &&
                'previousPeriod' in dataset[0]) {
                return dataset.every(function (item) {
                    var _a, _b;
                    return item.created === 0 &&
                        item.previousPeriod.value === 0 &&
                        ((_b = (_a = item.teamAverage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0) === 0;
                });
            }
            var firstItem = dataset[0];
            if ('labelName' in firstItem &&
                'meetings' in firstItem &&
                'documents' in firstItem &&
                'chatMessages' in firstItem &&
                'events' in firstItem) {
                var meetings = firstItem.meetings;
                if (meetings !== null &&
                    typeof meetings === 'object' &&
                    'count' in meetings &&
                    'prevPeriodDiff' in meetings) {
                    return dataset.every(function (item) {
                        return item.meetings.count === 0 &&
                            item.documents.count === 0 &&
                            item.chatMessages.count === 0 &&
                            item.events.count === 0;
                    });
                }
            }
            if ('labelName' in dataset[0] &&
                'meetings' in dataset[0] &&
                'documents' in dataset[0] &&
                'chatRooms' in dataset[0] &&
                'calendarEvents' in dataset[0]) {
                return dataset.every(function (item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return item.meetings === 0 &&
                        item.documents === 0 &&
                        item.chatRooms === 0 &&
                        item.calendarEvents === 0 &&
                        item.previousPeriod.documents.diff === 0 &&
                        item.previousPeriod.meetings.diff === 0 &&
                        item.previousPeriod.calendarEvents.diff === 0 &&
                        item.previousPeriod.chatRooms.diff === 0 &&
                        ((_b = (_a = item.teamAverage) === null || _a === void 0 ? void 0 : _a.documents.diff) !== null && _b !== void 0 ? _b : 0) === 0 &&
                        ((_d = (_c = item.teamAverage) === null || _c === void 0 ? void 0 : _c.meetings.diff) !== null && _d !== void 0 ? _d : 0) === 0 &&
                        ((_f = (_e = item.teamAverage) === null || _e === void 0 ? void 0 : _e.calendarEvents.diff) !== null && _f !== void 0 ? _f : 0) === 0 &&
                        ((_h = (_g = item.teamAverage) === null || _g === void 0 ? void 0 : _g.chatRooms.diff) !== null && _h !== void 0 ? _h : 0) === 0;
                });
            }
            if ('labelName' in dataset[0] &&
                'documents' in dataset[0] &&
                'spreadsheets' in dataset[0] &&
                'presentations' in dataset[0] &&
                'pdfs' in dataset[0] &&
                'other' in dataset[0] &&
                'previousPeriod' in dataset[0]) {
                return dataset.every(function (item) {
                    return item.documents === 0 &&
                        item.spreadsheets === 0 &&
                        item.presentations === 0 &&
                        item.pdfs === 0 &&
                        item.other === 0 &&
                        item.previousPeriod.documents.diff === 0 &&
                        item.previousPeriod.spreadsheets.diff === 0 &&
                        item.previousPeriod.presentations.diff === 0 &&
                        item.previousPeriod.pdfs.diff === 0 &&
                        item.previousPeriod.other.diff === 0;
                });
            }
            if ('labelName' in dataset[0] &&
                'totalAmount' in dataset[0] &&
                'totalDuration' in dataset[0] &&
                'numberOfParticipants' in dataset[0]) {
                return dataset.every(function (item) {
                    var _a, _b, _c, _d;
                    return item.totalAmount.current === 0 &&
                        item.totalDuration.current === '' &&
                        item.numberOfParticipants.current === 0 &&
                        item.totalAmount.previous.diff === 0 &&
                        ((_b = (_a = item.totalAmount.teamAverage) === null || _a === void 0 ? void 0 : _a.diff) !== null && _b !== void 0 ? _b : 0) === 0 &&
                        item.totalDuration.previous.diff === 0 &&
                        ((_d = (_c = item.totalDuration.teamAverage) === null || _c === void 0 ? void 0 : _c.diff) !== null && _d !== void 0 ? _d : 0) === 0 &&
                        item.numberOfParticipants.previous.diff === 0;
                });
            }
            if ('title' in dataset[0] &&
                'currentPeriod' in dataset[0] &&
                'previousPeriod' in dataset[0] &&
                'total' in dataset[0]) {
                return dataset.every(function (item) {
                    return item.currentPeriod.views === 0 &&
                        item.currentPeriod.edits === 0 &&
                        item.currentPeriod.comments === 0 &&
                        item.currentPeriod.downloads === 0;
                });
            }
            if ('labelName' in dataset[0] &&
                'drive' in dataset[0] &&
                'chat' in dataset[0] &&
                'meetings' in dataset[0]) {
                return dataset.every(function (item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return item.drive.count === 0 &&
                        ((_b = (_a = item.documents) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0) === 0 &&
                        item.chat.count === 0 &&
                        item.meetings.count === 0 &&
                        item.drive.userDiff.diff === 0 &&
                        ((_e = (_d = (_c = item.documents) === null || _c === void 0 ? void 0 : _c.userDiff) === null || _d === void 0 ? void 0 : _d.diff) !== null && _e !== void 0 ? _e : 0) === 0 &&
                        item.chat.userDiff.diff === 0 &&
                        item.meetings.userDiff.diff === 0 &&
                        item.drive.orgUnitAvgDiff.diff === 0 &&
                        ((_h = (_g = (_f = item.documents) === null || _f === void 0 ? void 0 : _f.orgUnitAvgDiff) === null || _g === void 0 ? void 0 : _g.diff) !== null && _h !== void 0 ? _h : 0) === 0 &&
                        item.chat.orgUnitAvgDiff.diff === 0 &&
                        item.meetings.orgUnitAvgDiff.diff === 0;
                });
            }
            if ('peerType' in dataset[0] &&
                'drive' in dataset[0] &&
                'chat' in dataset[0] &&
                'meetings' in dataset[0]) {
                return dataset.every(function (item) {
                    return item.drive.count === 0 &&
                        item.chat.count === 0 &&
                        item.meetings.count === 0;
                });
            }
            if ('period' in dataset[0] &&
                'startWorkTime' in dataset[0] &&
                'teamAverageStartWorkTime' in dataset[0] &&
                'endWorkTime' in dataset[0] &&
                'teamAverageEndWorkTime' in dataset[0] &&
                !('items' in dataset[0])) {
                var hasData = dataset.some(function (item) {
                    return (item.startWorkTime !== null && item.startWorkTime !== '') ||
                        (item.endWorkTime !== null && item.endWorkTime !== '') ||
                        (item.teamAverageStartWorkTime !== null &&
                            item.teamAverageStartWorkTime !== '') ||
                        (item.teamAverageEndWorkTime !== null &&
                            item.teamAverageEndWorkTime !== '');
                });
                return !hasData;
            }
            if ('period' in dataset[0] && 'items' in dataset[0]) {
                return dataset.every(function (item) { return item.items.length === 0; });
            }
            if ('name' in dataset[0] &&
                'orgUnitName' in dataset[0] &&
                'meetings' in dataset[0] &&
                'documents' in dataset[0] &&
                'chats' in dataset[0]) {
                return dataset.every(function (item) {
                    return item.meetings.count === 0 &&
                        item.documents === 0 &&
                        item.chats === 0;
                });
            }
            if ('weekday' in dataset[0] && 'previousPeriod' in dataset[0]) {
                return dataset.every(function (item) {
                    return item.previousPeriod.meetingsDuration === 0 &&
                        item.previousPeriod.docsDuration === 0 &&
                        item.previousPeriod.chatDuration === 0 &&
                        item.currentPeriod.meetingsDuration === 0 &&
                        item.currentPeriod.docsDuration === 0 &&
                        item.currentPeriod.chatDuration === 0 &&
                        item.team.meetingsDuration === 0 &&
                        item.team.docsDuration === 0 &&
                        item.team.chatDuration === 0;
                });
            }
            if ('roomName' in dataset[0] &&
                'messages' in dataset[0] &&
                'reactions' in dataset[0]) {
                return dataset.every(function (item) { return item.messages === 0 && item.reactions === 0; });
            }
            if ('userName' in dataset[0] &&
                'responses' in dataset[0] &&
                'avgResponseTime' in dataset[0]) {
                return dataset.every(function (item) { return item.responses === 0; });
            }
            if ('messagesSent' in dataset[0] &&
                'messagesReceived' in dataset[0] &&
                'department' in dataset[0]) {
                return dataset.every(function (item) { return item.messagesSent === 0 && item.messagesReceived === 0; });
            }
            if ('channel' in dataset[0] &&
                'avg' in dataset[0] &&
                ('total' in dataset[0] || 'count' in dataset[0])) {
                return dataset.every(function (item) {
                    var mainValue = 'total' in item ? item.total : item.count;
                    return mainValue === 0 && item.avg === 0;
                });
            }
        }
        return insightsData.length === 0;
    }
    if (typeof insightsData === 'object') {
        if ('teamMembers' in insightsData &&
            'totals' in insightsData &&
            Array.isArray(insightsData.teamMembers)) {
            var individualCommData = insightsData;
            var teamMembersEmpty = individualCommData.teamMembers.length === 0 ||
                individualCommData.teamMembers.every(function (member) {
                    return member.meet === 0 &&
                        member.chat === 0 &&
                        member.prevMeet === 0 &&
                        member.prevChat === 0;
                });
            var totalsEmpty = individualCommData.totals.meet.current === 0 &&
                individualCommData.totals.chat.current === 0;
            return teamMembersEmpty && totalsEmpty;
        }
        if ('totals' in insightsData &&
            ('periods' in insightsData ||
                'periodsData' in insightsData ||
                'currentPeriod' in insightsData)) {
            var totals = insightsData.totals;
            if ('attendedCount' in totals &&
                'missedCount' in totals &&
                'attendedDuration' in totals &&
                'missedDuration' in totals) {
                return (totals.attendedCount === 0 &&
                    totals.missedCount === 0 &&
                    totals.attendedDuration === 0 &&
                    totals.missedDuration === 0);
            }
            if ('planned' in totals &&
                'adhoc' in totals &&
                ((_a = totals.planned) === null || _a === void 0 ? void 0 : _a.current) !== undefined &&
                ((_b = totals.adhoc) === null || _b === void 0 ? void 0 : _b.current) !== undefined) {
                return (totals.planned.current === 0 &&
                    totals.adhoc.current === 0 &&
                    ((_c = totals.planned.previous) === null || _c === void 0 ? void 0 : _c.diff) === 0 &&
                    ((_d = totals.adhoc.previous) === null || _d === void 0 ? void 0 : _d.diff) === 0);
            }
            if ('attended' in totals &&
                'skipped' in totals &&
                ((_e = totals.attended) === null || _e === void 0 ? void 0 : _e.current) !== undefined &&
                ((_f = totals.skipped) === null || _f === void 0 ? void 0 : _f.current) !== undefined) {
                return totals.attended.current === 0 && totals.skipped.current === 0;
            }
            if ('sent' in totals &&
                'received' in totals &&
                'opened' in totals &&
                'replied' in totals &&
                'linkClicked' in totals &&
                'otherEvents' in totals) {
                return (totals.sent.current === 0 &&
                    totals.received.current === 0 &&
                    totals.opened.current === 0 &&
                    totals.replied.current === 0 &&
                    totals.linkClicked.current === 0 &&
                    totals.otherEvents.current === 0);
            }
            if ('messagesSent' in totals &&
                'reactionsSent' in totals &&
                'messagesReceived' in totals &&
                'reactionsReceived' in totals) {
                return (totals.messagesSent.current === 0 &&
                    totals.reactionsSent.current === 0 &&
                    totals.messagesReceived.current === 0 &&
                    totals.reactionsReceived.current === 0);
            }
            if ('meetingCount' in totals &&
                'durationSeconds' in totals &&
                ((_g = totals.meetingCount) === null || _g === void 0 ? void 0 : _g.current) !== undefined &&
                ((_h = totals.durationSeconds) === null || _h === void 0 ? void 0 : _h.current) !== undefined &&
                ((_j = totals.meetingCount) === null || _j === void 0 ? void 0 : _j.previous) !== undefined &&
                ((_k = totals.durationSeconds) === null || _k === void 0 ? void 0 : _k.previous) !== undefined &&
                !('sent' in totals) &&
                !('messagesSent' in totals)) {
                var optionalMetricsEmpty = ((_m = (_l = totals.manHoursSeconds) === null || _l === void 0 ? void 0 : _l.current) !== null && _m !== void 0 ? _m : 0) === 0 &&
                    ((_p = (_o = totals.avgParticipants) === null || _o === void 0 ? void 0 : _o.current) !== null && _p !== void 0 ? _p : 0) === 0;
                return (totals.meetingCount.current === 0 &&
                    totals.durationSeconds.current === 0 &&
                    optionalMetricsEmpty);
            }
            if ('createdAndOwnedFiles' in totals &&
                'previousPeriod' in totals &&
                'teamAverage' in totals) {
                return (totals.createdAndOwnedFiles === 0 &&
                    totals.previousPeriod === 0 &&
                    totals.teamAverage === 0);
            }
            if ('docsSharedExternally' in totals &&
                'previousPeriod' in totals &&
                'teamAverage' in totals) {
                return (totals.docsSharedExternally === 0 &&
                    totals.previousPeriod === 0 &&
                    totals.teamAverage === 0);
            }
            if ('userInternalSharing' in totals &&
                'userExternalSharing' in totals &&
                'teamInternalSharing' in totals &&
                'teamExternalSharing' in totals &&
                'teamDiffInternal' in totals &&
                'teamDiffExternal' in totals) {
                return (totals.userInternalSharing === 0 &&
                    totals.userExternalSharing === 0 &&
                    totals.teamInternalSharing === 0 &&
                    totals.teamExternalSharing === 0);
            }
            if ('officeHours' in totals && 'remoteHours' in totals) {
                return totals.officeHours === 0 && totals.remoteHours === 0;
            }
            if ('docsCommentsPosted' in totals &&
                'meetingsOrganized' in totals &&
                'chatMessagesSent' in totals &&
                'emailsSent' in totals &&
                'prevPeriodDiffs' in totals &&
                'teamAverageDiffs' in totals) {
                return (totals.docsCommentsPosted === 0 &&
                    totals.meetingsOrganized === 0 &&
                    totals.chatMessagesSent === 0 &&
                    totals.emailsSent === 0);
            }
            if ('accepted' in totals &&
                'rejected' in totals &&
                ((_q = totals.accepted) === null || _q === void 0 ? void 0 : _q.current) !== undefined &&
                ((_r = totals.rejected) === null || _r === void 0 ? void 0 : _r.current) !== undefined) {
                var acceptedEmpty = totals.accepted.current === 0 &&
                    ((_s = totals.accepted.previous) === null || _s === void 0 ? void 0 : _s.diff) === 0 &&
                    ((_u = (_t = totals.accepted.teamAverage) === null || _t === void 0 ? void 0 : _t.diff) !== null && _u !== void 0 ? _u : 0) === 0;
                var rejectedEmpty = totals.rejected.current === 0 &&
                    ((_v = totals.rejected.previous) === null || _v === void 0 ? void 0 : _v.diff) === 0 &&
                    ((_x = (_w = totals.rejected.teamAverage) === null || _w === void 0 ? void 0 : _w.diff) !== null && _x !== void 0 ? _x : 0) === 0;
                return acceptedEmpty && rejectedEmpty;
            }
            if ('meet' in totals &&
                'chat' in totals &&
                ((_y = totals.meet) === null || _y === void 0 ? void 0 : _y.current) !== undefined &&
                ((_z = totals.chat) === null || _z === void 0 ? void 0 : _z.current) !== undefined) {
                var totalsEmpty = totals.meet.current === 0 &&
                    totals.chat.current === 0 &&
                    (((_0 = totals.meet.previous) === null || _0 === void 0 ? void 0 : _0.diff) === 0 ||
                        ((_1 = totals.meet.previous) === null || _1 === void 0 ? void 0 : _1.diff) === undefined) &&
                    (((_2 = totals.chat.previous) === null || _2 === void 0 ? void 0 : _2.diff) === 0 ||
                        ((_3 = totals.chat.previous) === null || _3 === void 0 ? void 0 : _3.diff) === undefined);
                return totalsEmpty;
            }
        }
        if ('periods' in insightsData &&
            'prevPeriods' in insightsData &&
            'totals' in insightsData &&
            insightsData.totals &&
            typeof insightsData.totals === 'object' &&
            'missedCount' in insightsData.totals &&
            'attendedCount' in insightsData.totals) {
            var meetingAttendanceData = insightsData;
            if (meetingAttendanceData.periods.length === 0) {
                return (meetingAttendanceData.totals.attendedCount === 0 &&
                    meetingAttendanceData.totals.missedCount === 0);
            }
            return (meetingAttendanceData.totals.attendedCount === 0 &&
                meetingAttendanceData.totals.missedCount === 0 &&
                meetingAttendanceData.periods.every(function (period) { return period.meetings.length === 0; }));
        }
        if ('edited' in insightsData && 'viewed' in insightsData) {
            var activityResponse = insightsData;
            return Object.values(activityResponse).every(function (array) { return array.length === 0; });
        }
        if ('Initiated' in insightsData && 'Received' in insightsData) {
            var communicationData = insightsData;
            var initiatedEmpty = communicationData.Initiated.every(function (item) {
                return item.total === 0 &&
                    item.prevTotal === 0 &&
                    item.avg === 0 &&
                    item.userPrevPeriodDiff.diff === 0 &&
                    item.avgPrevPeriodDiff.diff === 0;
            });
            var receivedEmpty = communicationData.Received.every(function (item) {
                return item.count === 0 &&
                    item.prevTotal === 0 &&
                    item.avg === 0 &&
                    item.userPrevPeriodDiff.diff === 0 &&
                    item.avgPrevPeriodDiff.diff === 0;
            });
            return initiatedEmpty && receivedEmpty;
        }
        if ('total' in insightsData && 'data' in insightsData) {
            var alertsResponse = insightsData;
            return alertsResponse.total === 0 && alertsResponse.data.length === 0;
        }
        if ('documents' in insightsData && Array.isArray(insightsData.documents)) {
            return insightsData.documents.every(function (item) { return item.commentsResolved === 0 && item.suggestionsResolved === 0; });
        }
        if ('sent' in insightsData &&
            'received' in insightsData &&
            'internalReplyRate' in insightsData &&
            'internalSentWithNoReply' in insightsData &&
            'forwarded' in insightsData) {
            var summary = insightsData;
            return (summary.sent.count === 0 &&
                summary.received.count === 0 &&
                summary.internalReplyRate.numerator === 0 &&
                summary.openedEmails.count === 0 &&
                summary.forwarded.count === 0);
        }
        if ('document' in insightsData &&
            'spreadsheet' in insightsData &&
            'presentation' in insightsData &&
            'other' in insightsData &&
            !('created' in insightsData)) {
            var activity_1 = insightsData;
            return ['document', 'spreadsheet', 'presentation', 'other'].every(function (typeKey) {
                var metrics = activity_1[typeKey];
                return (metrics.created.count === 0 &&
                    metrics.edited.count === 0 &&
                    metrics.viewed.count === 0 &&
                    metrics.shared.left.count === 0 &&
                    metrics.shared.right.count === 0 &&
                    metrics.comments.left.count === 0 &&
                    metrics.comments.right.count === 0 &&
                    metrics.suggestions.left.count === 0 &&
                    metrics.suggestions.right.count === 0);
            });
        }
        if ('created' in insightsData &&
            'edited' in insightsData &&
            'viewed' in insightsData &&
            'commentsAdded' in insightsData &&
            'commentsResolved' in insightsData &&
            'suggestionsAdded' in insightsData &&
            'suggestionsResolved' in insightsData &&
            'shared' in insightsData &&
            'sharedExternally' in insightsData) {
            var summary = insightsData;
            return (summary.created.count === 0 &&
                summary.edited.count === 0 &&
                summary.viewed.count === 0 &&
                summary.commentsAdded.count === 0 &&
                summary.commentsResolved.count === 0 &&
                summary.suggestionsAdded.count === 0 &&
                summary.suggestionsResolved.count === 0 &&
                summary.shared.count === 0 &&
                summary.sharedExternally.count === 0);
        }
        if ('viewsEdits' in insightsData &&
            'commentsSuggestions' in insightsData &&
            'downloadsPrints' in insightsData &&
            'sharing' in insightsData &&
            'collaborators' in insightsData) {
            var summary = insightsData;
            return (summary.viewsEdits.left.count === 0 &&
                summary.viewsEdits.right.count === 0 &&
                summary.commentsSuggestions.left.count === 0 &&
                summary.commentsSuggestions.right.count === 0 &&
                summary.downloadsPrints.left.count === 0 &&
                summary.downloadsPrints.right.count === 0 &&
                summary.sharing.internal.count === 0 &&
                summary.sharing.external.count === 0 &&
                summary.collaborators.count === 0);
        }
        if ('messagesSentReceived' in insightsData &&
            'reactionsSentReceived' in insightsData &&
            'whereChatHappens' in insightsData &&
            'oneToOneVsGroup' in insightsData &&
            'oneToOneRoomsGroups' in insightsData &&
            'activeChattersAvgMsgPerSender' in insightsData &&
            'externalShareMessages' in insightsData &&
            'externalPartners' in insightsData) {
            var summary = insightsData;
            return (summary.messagesSentReceived.left.count === 0 &&
                summary.messagesSentReceived.right.count === 0 &&
                summary.reactionsSentReceived.left.count === 0 &&
                summary.reactionsSentReceived.right.count === 0 &&
                summary.externalPartners.count === 0);
        }
        if ('weeks' in insightsData &&
            'usersInScope' in insightsData &&
            Array.isArray(insightsData.weeks)) {
            return insightsData.weeks.length === 0;
        }
        if ('segments' in insightsData &&
            'summary' in insightsData &&
            Array.isArray(insightsData.segments)) {
            return (insightsData.segments
                .length === 0);
        }
        if ('apps' in insightsData &&
            'summary' in insightsData &&
            Array.isArray(insightsData.apps)) {
            return (insightsData.apps.length === 0);
        }
        if ('standaloneInAppUsage' in insightsData &&
            'totalActions' in insightsData &&
            ('usersInScope' in insightsData || 'categories' in insightsData)) {
            var summary = insightsData;
            return summary.totalActions.count === 0;
        }
        if ('meetingsAttended' in insightsData &&
            'totalDuration' in insightsData &&
            'oneToOneVsGroup' in insightsData &&
            'internalVsExternal' in insightsData &&
            'recurringVsAdhoc' in insightsData) {
            var summary = insightsData;
            return (summary.meetingsAttended.count === 0 &&
                summary.totalDuration.seconds === 0 &&
                ((_5 = (_4 = summary.manHours) === null || _4 === void 0 ? void 0 : _4.seconds) !== null && _5 !== void 0 ? _5 : 0) === 0);
        }
        if ('rows' in insightsData && Array.isArray(insightsData.rows)) {
            var rows = insightsData.rows;
            if (rows.length === 0) {
                return true;
            }
            var firstRow = rows[0];
            if (firstRow !== null &&
                typeof firstRow === 'object' &&
                'meetingCount' in firstRow &&
                'durationSeconds' in firstRow &&
                typeof firstRow.meetingCount ===
                    'object' &&
                firstRow.meetingCount !== null &&
                'current' in
                    firstRow.meetingCount) {
                return rows.every(function (row) {
                    var metricRow = row;
                    return (metricRow.meetingCount.current === 0 &&
                        metricRow.durationSeconds.current === 0);
                });
            }
        }
        return Object.keys(insightsData).length === 0;
    }
    return true;
}
export var isAiButtonDisabled = isInsightsDataEmpty;
var scopes = {
    user: [],
    manager: [ScopeUIFilterEnum.FILTER_ORG_UNIT, ScopeUIFilterEnum.FILTER_USER],
    admin: [
        ScopeUIFilterEnum.FILTER_ORG_UNIT,
        ScopeUIFilterEnum.FILTER_USER,
        ScopeUIPageEnum.PAGE_SETTINGS,
        ScopeUIPageEnum.PAGE_DOC_ALERTS
    ]
};
export var getUserScope = function (role) {
    if (!role) {
        return [];
    }
    switch (role) {
        case UserRoles.USER:
            return scopes.user;
        case UserRoles.MANAGER:
            return scopes.manager;
        case UserRoles.ADMIN:
            return scopes.admin;
        default:
            return [];
    }
};
export var hasScopeFun = function (scope, scopes) {
    if (!scopes)
        return false;
    return scopes.includes(scope);
};
export var filterUsersByOrgUnitAndRole = function (users, orgUnitId, role) {
    var filtered = users;
    if (orgUnitId) {
        filtered = filtered.filter(function (user) { var _a; return ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) === orgUnitId; });
    }
    if (role) {
        filtered = filtered.filter(function (user) { return user.role === role; });
    }
    return filtered;
};
export var getUserOrgUnit = function (user) {
    var _a, _b;
    return (_b = (_a = user === null || user === void 0 ? void 0 : user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
};
export var getOrgUnitNameWithParent = function (orgUnit) {
    var _a;
    if (!(orgUnit === null || orgUnit === void 0 ? void 0 : orgUnit.path))
        return (_a = orgUnit === null || orgUnit === void 0 ? void 0 : orgUnit.title) !== null && _a !== void 0 ? _a : null;
    return orgUnit.path.split('/').filter(Boolean).join(' > ');
};
export var getApplicationIconByType = function (type) {
    switch (type) {
        case ApplicationEnum.CHAT:
            return _jsx(GoogleChatIcon, {});
        case ApplicationEnum.DRIVE:
            return _jsx(GoogleDocIcon, { width: "20", height: "20" });
        case ApplicationEnum.MEET:
            return _jsx(GoogleMeetIconTable, {});
        case ApplicationEnum.GMAIL:
            return _jsx(GoogleGmailIcon, {});
        case ApplicationEnum.CALENDAR:
            return _jsx(GoogleCalendarIcon, {});
        default:
            return null;
    }
};
export var getIconByItemType = function (type) {
    switch (type) {
        case ItemsByType.DOCUMENTS:
            return getApplicationIconByType(ApplicationEnum.DRIVE);
        case ItemsByType.MEETINGS:
            return getApplicationIconByType(ApplicationEnum.MEET);
        case ItemsByType.CALENDAR_EVENTS:
            return getApplicationIconByType(ApplicationEnum.CALENDAR);
        case ItemsByType.CHAT_ROOMS:
            return getApplicationIconByType(ApplicationEnum.CHAT);
        default:
            return null;
    }
};
export var getHeatmapColorByDirectMatch = function (data, count) {
    var exactMatch = data.find(function (obj) { return obj.id === count; });
    if (exactMatch)
        return exactMatch;
    var maxId = Math.max.apply(Math, data.map(function (obj) { return obj.id; }));
    if (count > maxId) {
        return data.find(function (obj) { return obj.id === maxId; }) || data[data.length - 1];
    }
    return data[0];
};
export var getPerformanceReviewSectionComponent = function (section, userId, orgUnitId, dateFrom, dateTo, options) {
    var isSecondaryDiffHidden = (options === null || options === void 0 ? void 0 : options.isSecondaryDiffHidden) === true;
    switch (section) {
        case PerformanceReviewSectionsEnum.OVERVIEW:
            return (_jsx(OverviewSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo }));
        case PerformanceReviewSectionsEnum.COMMUNICATION:
            return (_jsx(CommunicationSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo, isSecondaryDiffHidden: isSecondaryDiffHidden }));
        case PerformanceReviewSectionsEnum.INITIATIVE_AND_OWNERSHIP:
            return (_jsx(InitiativeAndOwnershipSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo, isSecondaryDiffHidden: isSecondaryDiffHidden }));
        case PerformanceReviewSectionsEnum.SCHEDULE_AND_ATTENDANCE:
            return (_jsx(ScheduleAndAttendanceSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo }));
        case PerformanceReviewSectionsEnum.WORK_LIFE_BALANCE:
            return _jsx(WorkLifeBalanceSection, { userId: userId, orgUnitId: orgUnitId });
        case PerformanceReviewSectionsEnum.POLICY_COMPLIANCE:
            return (_jsx(PolicyComplianceSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo, isSecondaryDiffHidden: isSecondaryDiffHidden }));
        case PerformanceReviewSectionsEnum.AI_ADOPTION_AND_USAGE:
            return (_jsx(AIAdoptionAndUsageSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo, isSecondaryDiffHidden: isSecondaryDiffHidden }));
        case PerformanceReviewSectionsEnum.TIME_MANAGEMENT:
            return (_jsx(TimeManagement, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo, isSecondaryDiffHidden: isSecondaryDiffHidden }));
        case PerformanceReviewSectionsEnum.DAILY_TIMELINE:
            return _jsx(DailyTimelineSection, { userId: userId, orgUnitId: orgUnitId });
    }
};
